<template>
  <li
    class="col-span-1 flex shadow-sm rounded-md sm:hover:scale-150 hover:z-50 transition duration-500 ease-in-out transform"
  >
    <a
      :href="picture"
      target="_blank"
      :style="{ backgroundImage: `url('${picture}')` }"
      class="w-16 rounded-l-md bg-cover bg-center bg-indigo-300"
    />
    <div
      class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
    >
      <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
        <span
          class="text-gray-900 font-medium"
        >
          {{ firstName }} {{ lastName }}
        </span>
        <p class="text-gray-500">
          <a
            :href="`mailto:${email}`"
            class="hover:underline"
          >{{ email }}</a>
        </p>
      </div>
    </div>
  </li>
</template>
<script lang="ts">
/* eslint-disable no-unused-vars */

import { Student } from '@/config'
import { defineComponent, PropType } from 'vue'
import { normalizeForSearch } from '@/utils'

export default defineComponent({
  name: 'Student',
  props: {
    student: {
      type: Object as PropType<Student>,
      required: true,
    },
  },
  // eslint-disable-next-line vue/no-setup-props-destructure
  setup({ student }) {
    return {
      ...student,
      picture: normalizeForSearch(`/pictures/${student.group}/${student.lastName}_${student.firstName}.jpg`),
    }
  },
})
</script>
